module.exports = __webpack_public_path__ + "service-link.svg";